// Remove trailing zeros after decimal point
// including decimal point itself
export function trimTrailingDecimals(value) {
  if (typeof value !== 'string') return value; // Use regex that preserves currency symbols, percent signs, etc.

  return value.replace(/(\d+)\.0+(?=\D*$|\s*$)/, '$1') // Remove ".00" entirely
  .replace(/(\d+\.\d*?)0+(?=\D*$|\s*$)/, '$1'); // Remove trailing zeros
}